const loadPromises = new Map();

/**
 * Load reCAPTCHA v3 (required after async page transitions — base.twig scripts are not re-run).
 */
export function loadRecaptcha(siteKey) {
    if (!siteKey) {
        return Promise.resolve();
    }

    if (typeof window.grecaptcha !== 'undefined') {
        return Promise.resolve();
    }

    if (loadPromises.has(siteKey)) {
        return loadPromises.get(siteKey);
    }

    const promise = new Promise((resolve, reject) => {
        const existing = document.querySelector('script[src*="google.com/recaptcha/api.js"]');

        if (existing) {
            const onLoad = () => {
                existing.removeEventListener('load', onLoad);
                existing.removeEventListener('error', onError);
                resolve();
            };
            const onError = () => {
                existing.removeEventListener('load', onLoad);
                existing.removeEventListener('error', onError);
                reject(new Error('reCAPTCHA script failed to load'));
            };

            existing.addEventListener('load', onLoad);
            existing.addEventListener('error', onError);

            if (typeof window.grecaptcha !== 'undefined') {
                onLoad();
            }
            return;
        }

        const script = document.createElement('script');
        script.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(siteKey)}`;
        script.async = true;
        script.onload = () => resolve();
        script.onerror = () => reject(new Error('reCAPTCHA script failed to load'));
        document.body.appendChild(script);
    });

    loadPromises.set(siteKey, promise);
    return promise;
}
